'use client';

import clsx from 'clsx';
import { useMemo } from 'react';

import styles from './Stars.module.scss';

const createSeededGenerator = (seed: number) => {
    let value = seed >>> 0;

    return () => {
        value = (value * 1664525 + 1013904223) >>> 0;
        return value / 0x100000000;
    };
};

const multipleBoxShadow = (count: number, seed: number) => {
    const next = createSeededGenerator(seed);
    const nextCoordinate = () => Math.floor(next() * 2000);
    let value = `${nextCoordinate()}px ${nextCoordinate()}px rgba(255,255,255,0.92)`;

    for (let index = 1; index < count; index += 1) {
        value += `, ${nextCoordinate()}px ${nextCoordinate()}px rgba(255,255,255,0.92)`;
    }

    return value;
};

type StarsProps = {
    className?: string;
    dataTestId?: string;
};

export const Stars = ({ className, dataTestId }: StarsProps) => {
    const layers = useMemo(
        () => ({
            one: multipleBoxShadow(240, 11),
            two: multipleBoxShadow(96, 29),
            three: multipleBoxShadow(44, 47),
        }),
        []
    );

    return (
        <div className={clsx(styles.root, className)} aria-hidden="true" data-testid={dataTestId}>
            <div className={`${styles.field} ${styles.fieldPrimary}`} style={{ boxShadow: layers.one }} data-testid="components-landing-stars-div" />
            <div className={`${styles.field} ${styles.fieldMid}`} style={{ boxShadow: layers.two }} data-testid="components-landing-stars-div-2" />
            <div className={`${styles.field} ${styles.fieldFar}`} style={{ boxShadow: layers.three }} data-testid="components-landing-stars-div-3" />
        </div>
    );
};
